var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileUploadChatbotIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.29103 3.2914L3.6817 9.0154C3.4316 9.2655 3.2911 9.60471 3.2911 9.9584C3.2911 10.3121 3.4316 10.6513 3.6817 10.9014C3.9318 11.1515 4.27101 11.292 4.6247 11.292C4.97839 11.292 5.3176 11.1515 5.5677 10.9014L11.177 5.1774C11.6771 4.67729 11.9581 3.999 11.9581 3.29174C11.9581 2.58447 11.6771 1.90618 11.177 1.40607C10.6769 0.905959 9.99863 0.625 9.29137 0.625C8.58411 0.625 7.90581 0.905959 7.4057 1.40607L1.8197 7.10674C1.4433 7.47705 1.14394 7.91823 0.9389 8.40483C0.733857 8.89142 0.627183 9.41379 0.625033 9.94182C0.622883 10.4698 0.725299 10.9931 0.926373 11.4813C1.12745 11.9696 1.4232 12.4132 1.79657 12.7865C2.16995 13.1599 2.61355 13.4557 3.10179 13.6567C3.59004 13.8578 4.11326 13.9602 4.64129 13.9581C5.16931 13.9559 5.69169 13.8492 6.17828 13.6442C6.66487 13.4392 7.10605 13.1398 7.47637 12.7634L13.0624 7.06274",
    stroke: "#8D8D8D",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadChatbotIcon);
export default __webpack_public_path__ + "static/media/FileUploadChatbotIcon.b581528a5c68c16fbfe955b153c4dcee.svg";
export { ForwardRef as ReactComponent };